'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Scrollbar = _interopDefault(require('smooth-scrollbar'));

var version = "0.0.0";

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Component = videojs.getComponent('Component');

/**
 * hot key overlay.
 */

var PanelAlert = function (_Component) {
    inherits(PanelAlert, _Component);

    function PanelAlert(player, options) {
        classCallCheck(this, PanelAlert);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this.player = player;
        _this.options = options;
        return _this;
    }

    PanelAlert.prototype.createEl = function createEl() {
        return _Component.prototype.createEl.call(this, 'div', {
            className: 'uep-panel-alert',
            id: "uep-panel-alert",
            innerHTML: '<div id="uep-panel-alert-text"></div>',
            // Don't want poster to be tabbable.
            tabIndex: -1
        });
    };

    PanelAlert.prototype.open = function open() {
        document.querySelector('#uep-panel-alert-text').innerHTML = this.options.alert;
        var uep_panel_alert = document.getElementById("uep-panel-alert");
        uep_panel_alert.classList.add("show");
        setTimeout(function () {
            uep_panel_alert.className = uep_panel_alert.className.replace("show", "");
        }, 5000);
        // var demo5 = new SimpleBar(document.getElementById('uepCutContainer'));
    };

    return PanelAlert;
}(Component);

function getFragment(uepMediaSequences) {
    var fragment = [];

    uepMediaSequences.forEach(function (element) {
        if (element.start !== element.end) {
            fragment.push({ startMedia: dateHHMMSS(element.start), endMedia: dateHHMMSS(element.end) });
        }
    });
    return fragment;
}

function dateHHMMSS(time) {
    var hours = Math.floor(time / 3600);
    time %= 3600;
    var minutes = Math.floor(time / 60);
    var seconds = time % 60;
    var addZero = function addZero(v) {
        return v < 10 ? '0' + v : v;
    };
    var t = [];

    t.push(addZero(hours));
    t.push(addZero(minutes));
    t.push(addZero(seconds));
    return t.join(':');
}
function sendData(vtitle, uepMediaSequences) {
    var HTTP = uepPlayer.optionsMontage.api.HTTP;
    var URL = uepPlayer.optionsMontage.api.URL;
    var client = uepPlayer.optionsMontage.api.client;
    var fragment = getFragment(uepMediaSequences);
    var params = {
        action: "cut",
        choix_new_video: vtitle !== null ? 1 : 0,
        cutNumber: fragment.length,
        fragment: fragment,
        video_id: uepPlayer.optionsMontage.api.videoId,
        titre_new_video: vtitle,
        client: client
    };

    HTTP.post(URL, params, {
        emulateJSON: true
    }).then(function (response) {
        if (response.data.code === 200) {}
    }, function (response) {
        console.log('api error');
        eventHub.$emit('error', { code: response.code, cause: response.message });
    });
}

var MediaSequence = function MediaSequence(start, end, title) {
    classCallCheck(this, MediaSequence);

    this.start = start;
    this.end = end;
    this.title = "";
};

var videojsPlayer = videojs.getComponent('Player');
var uepExtractWorkRequested = false;
var uepSequencesCount = 0;
videojsPlayer.prototype.getCurrentMediaSequence = function (s) {

    uep_getMediaSequencesCount();
    if (!uepExtractWorkRequested) {
        var seq = document.getElementById("uepCutSequence" + s);
        var has_new_element = false;
        var imageObj = new Image();
        imageObj.src = uepPlayer.poster();

        if (seq != null) {
            var values = {};
            values = this.getValueSlider();

            if (values != null) {

                if (document.getElementById("uepCutSequence" + (s + 1)) === null) {
                    var parent = seq.parentNode;
                    var wrapper = document.createElement('div');
                    parent.appendChild(createChildCanvas(s + 1));
                    has_new_element = true;
                }
                var videos = document.getElementsByClassName("vjs-tech");
                var video = videos[0];

                //var canvas = document.getElementById("uepTestCanvas");
                var canvas = document.getElementById("uepCutCanvas" + s);
                var divTime = document.getElementById("uep_time_cut" + s);
                var w = video.videoWidth;
                var h = video.videoHeight;
                var ctx = canvas.getContext('2d');
                if (uepPlayer.networkState() == 1) ctx.drawImage(video, 0, 0, w, h, 0, 0, canvas.width, canvas.height);else {
                    imageObj.onload = function () {
                        ctx.drawImage(imageObj, 0, 0, canvas.width, canvas.height);
                    };
                }
                /* else
                 ctx.drawImage(uepPlayer.poster(), 0, 0, w, h, 0, 0, canvas.width, canvas.height);*/

                if (uepMediaSequences[s] === undefined) {
                    uepMediaSequences[s] = new MediaSequence(0, 0, "");
                }
                uepMediaSequences[s].start = Math.round(values.start, 0);
                uepMediaSequences[s].end = Math.round(values.end, 0);
                /* if (uepMediaSequences[s].start !== 0)
                     this.currentTime(uepMediaSequences[s].start);*/
                canvas.title = videojs.formatTime(Math.round(values.start, 0)) + " -> " + videojs.formatTime(Math.round(values.end, 0));
                divTime.classList.remove("uep_time_cut_number_show");
                divTime.classList.add("uep_time_cut_number_hidden");

                seq.classList.remove("uep-cut-sequence-number");
                seq.classList.add("uep-cut-sequence-canvas");

                document.getElementById("uepButtonMontage").classList.remove("uepButtonDisabled");
                document.getElementById("uepButtonMontage").classList.add("uepButtonShow");

                document.getElementById("uepButtonExtractSave").classList.remove("uepButtonDisabled");
                document.getElementById("uepButtonExtractSave").classList.add("uepButtonSave");
                if (has_new_element) scrollDivCanvas();

                //uepPlayer.playBetween(uepMediaSequences[s].start,uepMediaSequences[s].end);
            }
        }

        document.getElementById("uepButtonExtractSave").style.display = "inline";
    }
};

function createChildCanvas(id) {
    var wrapper = document.createElement('div');

    wrapper.innerHTML = '<div class="uep-cut-sequence uep-cut-sequence-number" style="left: ' + id * 84 + ';" id="uepCutSequence' + id + '" onclick="uepPlayer.getCurrentMediaSequence(' + id + ')" draggable="true">\n           <div class="uep_time_cut' + id + ' uep_time_cut_number_show" id="uep_time_cut' + id + '"><span class="number_cut_sequence">+</span></div>\n           <canvas class="canvas_cut_seq" id="uepCutCanvas' + id + '" width="80" height="60" title="S\xE9lectionner une s\xE9quence avec les curseurs, puis cliquer sur cette zone"></canvas>\n        </div>';
    return wrapper.firstChild;
}

function scrollDivCanvas() {
    var elements = document.getElementsByClassName("scroll-content");
    var limitX = scrollBarUep.limit !== null && scrollBarUep.limit.x !== null ? scrollBarUep.limit.x : 500;
    if (elements.length > 0) {
        var element = elements[0];

        element.style.transform = "translate3d(-" + limitX + 100 + "px, 0px, 0px)";
        scrollBarUep.offset = { x: limitX + 100, y: 0 };
    }
}

function uep_getMediaSequencesCount() {
    var seqcount = 0;
    for (var s = 0; s < uepMaxMediaSequences; s++) {
        if (uepMediaSequences[s].start > 0 || uepMediaSequences[s].end > 0) {
            seqcount++;
        }
    }
    return seqcount;
}

videojsPlayer.prototype.showTitreVideo = function (e) {

    if (document.getElementById('checkTitleVideo').checked) {
        document.getElementById('uepInputTitleText').style.display = 'block';
    } else {
        document.getElementById('uepInputTitleText').style.display = 'none';
    }
};

videojsPlayer.prototype.playsSequencesMontage = function (element) {
    if (hasClass(element, "uepButtonDisabled")) return;
    uepPlayer.playsSequences(uepMediaSequences);
    uepPlayer.addClass("zoomOut");
};

function hasClass(element, className) {
    return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
}
videojsPlayer.prototype.extractMediaSequences = function (element) {

    if (hasClass(element, "uepButtonDisabled")) return;
    uepSequencesCount = uep_getMediaSequencesCount();
    if (uepSequencesCount > 0) {
        var uepInputTitleText = document.getElementById("uepInputTitleText");
        if (document.getElementById('checkTitleVideo').checked) {
            var vtitle = uepInputTitleText.value;
            if (vtitle == "" || vtitle == null || vtitle == undefined) {
                document.getElementById('uepInputTitleText').classList.add('inValidInput');
                return;
            }
        } else {
            var vtitle = null;
        }
        showAlert("Votre vidéo a bien été enregistrée");
        sendData(vtitle, uepMediaSequences);
        uepPlayer.getChild('PanelOverlay').modal.close();
        uepPlayer.hideSlider();
        uepExtractWorkRequested = false;
    } else {
        document.getElementById('uep_time_cut0').classList.add('inValidInput');
    }
};

function showAlert(text) {

    videojs.registerComponent('PanelAlert', PanelAlert);
    uepPlayer.addChild('PanelAlert', { alert: text });
    uepPlayer.getChild('PanelAlert').open();
}
videojsPlayer.prototype.closeMediaCutForm = function () {
    uepPlayer.getChild('PanelOverlay').modal.close();
    uepPlayer.hideSlider();
};

videojsPlayer.prototype.getValueSlider = function () {
    return this.rangeslider.getValues();
};

var Button = videojs.getComponent('Button');
/**
 * send mail button.
 */

var CutButton = function (_Button) {
  inherits(CutButton, _Button);

  function CutButton(player, options) {
    classCallCheck(this, CutButton);

    var _this = possibleConstructorReturn(this, _Button.call(this, player, options));

    _this.addClass('vjs-cut-button');
    _this.controlText(player.localize('Découper la vidéo'));
    _this.parent = options;
    return _this;
  }

  CutButton.prototype.handleClick = function handleClick() {
    this.player().getChild('PanelOverlay').open();
    //this.player().getChild('PanelModel').show();
  };

  return CutButton;
}(Button);

var ModalDialog = videojs.getComponent('ModalDialog');

/**
 * hot key modal.
 */

var PanelModal = function (_ModalDialog) {
  inherits(PanelModal, _ModalDialog);

  function PanelModal(player, options) {
    classCallCheck(this, PanelModal);

    var _this = possibleConstructorReturn(this, _ModalDialog.call(this, player, options));

    _this.playerClassName = 'vjs-videojs-panel_open';
    return _this;
  }

  PanelModal.prototype.open = function open() {
    if (!this.player().hasClass(this.playerClassName)) {
      this.player().addClass(this.playerClassName);
      _ModalDialog.prototype.open.call(this);
      this.player().trigger('panel:opened');
      this.player().removeClass("vjs-controls-disabled");
    }
  };

  PanelModal.prototype.close = function close() {
    this.player().trigger('panel:closed');
    this.player().removeClass(this.playerClassName);
    uepPlayer.hideSlider();
    _ModalDialog.prototype.close.call(this);
  };

  return PanelModal;
}(ModalDialog);

var PanelModalContent = function () {
    function PanelModalContent(player, options) {
        classCallCheck(this, PanelModalContent);

        this.player = player;

        this.options = options;
        this._createContent();
    }

    PanelModalContent.prototype.getContent = function getContent() {
        return this.content;
    };

    PanelModalContent.prototype._createContent = function _createContent() {
        var wrapper = document.createElement('div');

        wrapper.innerHTML = '<div class="vjs-panel-modal">\n\n<form id="frmCut" class="formCut">\n  <div class="uepBox"><div id="uepCutPanelTitle" name="uepCutPanelTitle" class="uepPanelTitle panel_label">D\xE9couper la\n    vid\xE9o</div><div  class="panel_label uepContent">\n    <div id="uepCutContainer" class="uep-cut-container" data-simplebar>\n    ' + this._createCutSequence().join('') + '\n    </div>\n    <div class="panel_ligne panel_title">\n     <div><input type="checkbox" class="checkbox" id="checkTitleVideo" onclick="uepPlayer.showTitreVideo(this);">\n     <label for="checkTitleVideo"><span></span>Cr\xE9er une nouvelle vid\xE9o</label>\n    </div>\n    <input type="text" id="uepInputTitleText" style="display: none;" placeholder="Titre de la vid\xE9o" class="input_title" required></div>\n   <div class="panel_ligne button_label">\n   <div>\n   <input type="button" id="uepButtonCancel" class="uepButton uepButtonCancel" onclick="uepPlayer.closeMediaCutForm();" value="Annuler">\n   <input type="button" class="uepButton uepButtonDisabled" id="uepButtonMontage" onclick="uepPlayer.playsSequencesMontage(this);" value="Visualiser le montage">\n   </div>\n   <input type="button" class="uepButton uepButtonDisabled" id="uepButtonExtractSave" onclick="uepPlayer.extractMediaSequences(this);" value="Enregistrer la vid\xE9o">\n   </div></div></div>\n</form></div>\n  ';
        this.content = wrapper.firstChild;
    };

    PanelModalContent.prototype._createCutSequence = function _createCutSequence() {
        var sequenceItems = [];
        var j = 0;
        sequenceItems.push('\n           <div class="uep-cut-sequence uep-cut-sequence-number" style="left: ' + j * 84 + ';" id="uepCutSequence' + j + '" onclick="uepPlayer.getCurrentMediaSequence(' + j + ')" draggable="true">\n           <div class="uep_time_cut' + j + ' uep_time_cut_number_show" id="uep_time_cut' + j + '"><span class="number_cut_sequence">+</span></div>\n        <canvas class="canvas_cut_seq" id="uepCutCanvas' + j + '" width="80" height="60" title="S\xE9lectionner une s\xE9quence avec les curseurs, puis cliquer sur cette zone"></canvas>\n      </div>\n        ');
        return sequenceItems;
    };

    return PanelModalContent;
}();

var Component$3 = videojs.getComponent('Button');
/**
 * send mail button.
 */

var ShowModalButton = function (_Component) {
    inherits(ShowModalButton, _Component);

    function ShowModalButton(player, options) {
        classCallCheck(this, ShowModalButton);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this.addClass('vjs-show-modal-button');
        _this.controlText(player.localize("Retour"));
        _this.parent = options;
        return _this;
    }

    ShowModalButton.prototype.handleClick = function handleClick() {
        this.player().removeClass("zoomOut");
        uepPlayer.unlockSlider();
        uepPlayer.closePlaySequence();
    };

    return ShowModalButton;
}(Component$3);

var Component$4 = videojs.getComponent('Button');
/**
 * send mail button.
 */

var ReplayButton = function (_Component) {
  inherits(ReplayButton, _Component);

  function ReplayButton(player, options) {
    classCallCheck(this, ReplayButton);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass('vjs-replay-button');
    _this.controlText(player.localize('Revoir'));
    _this.parent = options;
    return _this;
  }

  ReplayButton.prototype.handleClick = function handleClick() {
    uepPlayer.playsSequences(uepMediaSequences);
  };

  return ReplayButton;
}(Component$4);

var Component$2 = videojs.getComponent('Component');

/**
 * hot key overlay.
 */

var PanelPreview = function (_Component) {
    inherits(PanelPreview, _Component);

    function PanelPreview(player, options) {
        classCallCheck(this, PanelPreview);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        videojs.registerComponent('ShowModalButton', ShowModalButton);
        _this.addChild('ShowModalButton', options);
        videojs.registerComponent('ReplayButton', ReplayButton);
        _this.addChild('ReplayButton', options);
        _this.player = player;
        _this.options = options;
        return _this;
    }

    PanelPreview.prototype.createEl = function createEl() {
        return _Component.prototype.createEl.call(this, 'div', {
            className: 'uep-panel-preview',
            id: "preview",
            innerHTML: "<div></div>",
            // Don't want poster to be tabbable.
            tabIndex: -1
        });
    };

    PanelPreview.prototype.open = function open() {

        // var demo5 = new SimpleBar(document.getElementById('uepCutContainer'));
    };

    return PanelPreview;
}(Component$2);

var Component$1 = videojs.getComponent('Component');

var options = {
    damping: 0.1,
    thumbMinSize: 20,
    renderByPixels: !('ontouchstart' in document),
    alwaysShowTracks: false,
    continuousScrolling: true
};

var overscrollOptions = {
    enable: true,
    effect: navigator.userAgent.match(/Android/) ? 'glow' : 'bounce',
    damping: 0.2,
    maxOverscroll: 150,
    glowColor: '#222a2d'
};

/**
 * hot key overlay.
 */

var PanelOverlay = function (_Component) {
    inherits(PanelOverlay, _Component);

    function PanelOverlay(player, options) {
        classCallCheck(this, PanelOverlay);

        var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

        _this.player = player;
        _this.options = options;
        return _this;
    }

    PanelOverlay.prototype._createModal = function _createModal() {
        var content = new PanelModalContent(this.player, this.options).getContent();

        this.modal = new PanelModal(this.player, {
            content: content
            //pauseOnOpen: false,
            //temporary: true
        });
        this.el = this.modal.contentEl();
        this.player.addChild(this.modal);
    };

    PanelOverlay.prototype.open = function open() {

        if (!this.player.hasClass("vjs-videojs-panel_open")) {
            var myFu = function myFu(e) {
                var elements = document.getElementsByClassName("scroll-content");
                var x = s.offset !== null && s.offset.x !== null ? s.offset.x : 0;
                var limitX = s.limit !== null && s.limit.x !== null ? s.limit.x : 500;
                var pas = e.wheelDelta < 0 ? 1 : -1;
                var wheelDeltaX = x + pas * limitX / 2;
                if (wheelDeltaX >= 0 && wheelDeltaX <= limitX) s.offset = { x: wheelDeltaX, y: 0 };else if (wheelDeltaX < 0) s.offset = { x: 0, y: 0 };else s.offset = { x: limitX, y: 0 };
                if (elements.length > 0) {
                    var element = elements[0];
                    if (wheelDeltaX >= 0 && wheelDeltaX <= limitX) {
                        element.style.transform = "translate3d(-" + wheelDeltaX + "px, 0px, 0px)";
                    } else if (wheelDeltaX < 0) {
                        element.style.transform = "translate3d(" + 0 + "px, 0px, 0px)";
                    } else {
                        element.style.transform = "translate3d(-" + limitX + "px, 0px, 0px)";
                    }
                }
            };

            this._createModal();
            videojs.registerComponent('PanelPreview', PanelPreview);
            this.player.addChild('PanelPreview', options);
            this.modal.open();
            this.player_.showSlider();
            var s = Scrollbar.init(document.querySelector('#uepCutContainer'), options);
            window.scrollBarUep = s;
            document.getElementById("uepCutContainer").addEventListener("wheel", myFu);
        }

        // var demo5 = new SimpleBar(document.getElementById('uepCutContainer'));
    };

    return PanelOverlay;
}(Component$1);

// Default options for the plugin.
var defaults = {};

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;

console.log(videojs.VERSION);

window.uepExtractWorkRequested = false;
window.uepMediaSequences = new Array();
window.uepSequencesCount = 0;
window.uepMaxMediaSequences = 6;
// const dom = videojs.dom || videojs;


videojs.registerComponent('CutButton', CutButton);

videojs.registerComponent('PanelOverlay', PanelOverlay);
/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
    player.addClass('vjs-montage');

    // Cut button

    player.getChild("controlBar").addChild("CutButton", options);

    //player.addChild('PanelModel', options);
    player.addChild('PanelOverlay', options);
    window.uepPlayer = player;
    videojs.getComponent('Player').prototype.optionsMontage = options;
    uep_initMediaSequences();

    /* videojs.Player.prototype.closeMediaCutForm = function(tid) {
       ijs_clearMediaSequences();
     this.player_.controlBar.mediaCutFormPanel.el_.style.visibility = "hidden";
      //ijs_setPanelOpen(false);
      this.player_.hideSlider();
      }*/
};

function uep_initMediaSequences() {
    for (var s = 0; s < uepMaxMediaSequences; s++) {
        uepMediaSequences[s] = new MediaSequence(0, 0, "");
    }
}

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function montage
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var montage = function montage(options) {
    var _this = this;

    this.ready(function () {
        onPlayerReady(_this, videojs.mergeOptions(defaults, options));
    });
};

// Register the plugin with video.js.
registerPlugin('montage', montage);

// Include the version number.
montage.VERSION = version;

module.exports = montage;



//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_montage/dist/videojs-montage.cjs.js
// module id = 561
// module chunks = 1